import { types } from './reducer';

export const userActions = (state, dispatch) => ({
    login: (data) => dispatch({ type: types.LOGIN_USER, payload: data }),
    logout: () => dispatch({ type: types.LOGOUT_USER })
});
